import { Box, styled, Typography, TypographyProps } from '@mui/material';

export const Sub = styled(({ sx, ...props }: TypographyProps) => {
  let padText = 1;
  if (typeof props.children === 'string') {
    padText = props.children.length;
  }
  return (
    <Box
      component='span'
      sx={{
        display: 'inline-block',
        position: 'relative',
        m: 0,
        p: 0,
      }}
    >
      <Box
        component='span'
        sx={{
          '&::before': {
            fontSize: 'smaller',
            content: `"${''.padStart(padText, '0')}"`,
            opacity: 0,
          },
        }}
      />
      <Typography
        component='span'
        {...props}
        sx={{
          ...sx,
          m: 0,
          p: 0,
          position: 'absolute',
          top: '25%',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: 'smaller',
        }}
      />
    </Box>
  );
})(() => ({}));
